import { useEffect, useState, useRef } from "react";

export const useWindowScrollObserver = () => {
    const [isScrolling, setIsScrolling] = useState(false);
    const lastScrollTime = useRef(0);

    useEffect(() => {
        let animationId = 0
        const onScroll = () => {
            setIsScrolling(true);
            lastScrollTime.current = performance.now();
        };
        document.addEventListener("scroll", onScroll, true);
        const check = () => {
            const now = performance.now();
            if (isScrolling && now - lastScrollTime.current > 60) {
                setIsScrolling(false);
            }
            animationId = requestAnimationFrame(check);
        };
        animationId = requestAnimationFrame(check);

        return () => {
            document.removeEventListener("scroll", onScroll)
            cancelAnimationFrame(animationId);
        };
    }, [isScrolling]);

    return isScrolling;
};
